import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  TextInput,
  ActivityIndicator,
  FlatList,
  Modal,
  ScrollView,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import Colours from "../../utils/Colours";
import SearchIcon from "../../icons/SearchIcon";
import MoneyIcon from "../../icons/MoneyIcon";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import ClockIcon from "../../icons/ClockIcon";
import MeezaCreditTransactionHistory from "./MeezaCreditTransactionHistory";
import TransferTo from "./TransferTo";
import DoesIconn from "../../icons/DoesIconn";
import TransferFromTable from "../myTables/TransferFromTable";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import useAuth from "../../hooks/useAuth";
import UsernamePasswordTransactCode from "../settings/UsernamePasswordTransactCode";
import ViewMoreIcon from "../../icons/ViewMoreIcon";
import { SafeAreaView } from "react-native-safe-area-context";
import { useNavigation } from "expo-router";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MeezaCreditScreen = ({ hideScreen }) => {
  const [showMeezaCreditTransactHistory, setShowMeezaCreditTransactHistory] = useState(false);
  const [showUsernamePasswordTransactCode, setShowUsernamePasswordTransactCode] = useState(false);
  const [showTransferTo, setShowTransferTo] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [interBank, setInterBank] = useState(false);
  const [meezaTrans, setMeezaTrans] = useState(false);

  const [isInterBankLoading, setIsInterBankLoading] = useState(false);
  const [isMeezaLoading, setIsMeezaLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isButtonClickedd, setIsButtonClickedd] = useState(false);
  const [useAvailableCredits, setUserAvailableCredit] = useState(true);
  const [showBodyTableCreditCategory, setShowBodyTableCreditCategory] = useState(false);
  const [showTransferFromMeezaCredit, setShowTransferFromMeezaCredit] = useState(false);

  const [passwordIsCorrect, setPasswordIsCorrect] = useState(false);
  const [credits, setCredits] = useState("");
  const [cashOut, setCashOut] = useState("");

  const axiosPrivate = useAxiosPrivate();

  const { isReverified, updateInteraction, reverifyUser, activitySettings } = useAuth();

  const [isFormContainerClicked, setIsFormContainerClicked] = useState(false);
  const [showPaymentReceipt, setShowPaymentReceipt] = useState(false);
  const [showConfirmTransfer, setShowConfirmTransfer] = useState(false);

  const scrollViewRef = useRef(null);
  const navigation = useNavigation();

  useEffect(() => {
    if (passwordIsCorrect) {
      reverifyUser();
      // optionally reset to false if you don’t want it to run multiple times
      setPasswordIsCorrect(false);
    }
  }, [passwordIsCorrect, reverifyUser]);

  useEffect(() => {
    if (!isReverified) {
      //console.log('Timer is up, isReverified is now false.');
    }
  }, [isReverified]);

  useEffect(() => {
    fetchUserMeezaCredit();
  }, []);

  const hideAllPayScreens = () => {
    setShowPaymentReceipt(false);
    setShowConfirmTransfer(false);
    setShowTransferFromMeezaCredit(false);
  };

  /***FETCH MEEZA CREDITS AND CASHOUTS */
  const fetchUserMeezaCredit = async () => {
    setIsLoadings(true);
    try {
      // Make the axios POST request to the backend
      const response = await axiosPrivate.get("/userCredits/userCredits");

      // //console.log('responsexx', response)

      // Handle success response
      if (response.status === 200 || response.status === 201) {
        //console.log('meeza credit fetched:', response.data);

        setCredits(Number(response.data.meezaCredits).toLocaleString());
        setCashOut(Number(response.data.cashOut).toLocaleString());

        // Use response.data.customerId if needed for further processing
      } else {
        //console.error('Unexpected response:', response);
      }
    } catch (error) {
      if (error.response) {
        //console.error('Error response from server:', error.response.data);
      } else if (error.request) {
        //console.error('No response received:', error.request);
      } else {
        //console.error('Error setting up the request:', error.message);
      }
    } finally {
      setIsLoadings(false);
    }
  };

  const handleInterBankTransfer = () => {
    if (!activitySettings.canBankTransfer) {
      setErrorMessage("Bank transfer is not available at the moment, please try again later");
      setIsErrorCompVisible(true);
      return;
    }

    if (!isReverified) {
      setShowUsernamePasswordTransactCode(true);
      return;
    }

    // User is reverified and bank transfer is allowed
    updateInteraction();
    setShowTransferFromMeezaCredit(true);
  };

  const handleMeezaTransfer = () => {
    if (!activitySettings.canMeezaTransfer) {
      setErrorMessage("Meeza transfer is not available at the moment, please try again later");
      setIsErrorCompVisible(true);
      return;
    }

    if (!isReverified) {
      setShowUsernamePasswordTransactCode(true);
      return;
    }

    // User is reverified and bank transfer is allowed
    updateInteraction();
    setShowTransferTo(true);
  };

  const handleViewMeezaCreditTransactions = () => {
    updateInteraction();
    setShowMeezaCreditTransactHistory(true);
  };
  const handleMeezaCredits = () => {
    updateInteraction();
    setUserAvailableCredit(false);
    setShowBodyTableCreditCategory(true);
  };

  return (
    <SafeAreaView style={{ backgroundColor: "white" }}>
      <TopHeaderComponent headerText={"Meeza Credit"} hideScreen={() => navigation.goBack()} />
      <ScrollView
        ref={scrollViewRef}
        style={styles.componentStyle}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        {/* {selectedTable ?
                    <> */}

        <View style={styles.textboxAmountContainer2}>
          <View style={styles.textboxHeader}>
            <Text style={styles.meezaCreditBalanceTxt}>Meeza Credit Balance</Text>
          </View>

          <View style={styles.tableAmountContainer}>
            <MoneyIcon
              color={Colours.PRIMARY_LIGHT}
              width={dynamicSize(30)}
              height={dynamicSize(30)}
            />
            <Text style={styles.creditsTxt}>Credits:</Text>
            {isLoadings ? (
              <ActivityIndicator size="small" color={Colours.PRIMARY} />
            ) : (
              <>
                <Text style={styles.creditsValueTxt}>{isReverified ? credits : "**** "}</Text>
                {isReverified ? (
                  ""
                ) : (
                  <TouchableOpacity
                    onPress={() => {
                      setShowUsernamePasswordTransactCode(true);
                    }}
                  >
                    <ViewMoreIcon color={Colours.MIDGRAY} />
                  </TouchableOpacity>
                )}
              </>
            )}
          </View>
          {/* 
          <TouchableOpacity
            style={[
              styles.buttonGray,
              { backgroundColor: isButtonClickedd ? Colours.PRIMARY : Colours.LIGHTGRAY },
            ]}
            onPress={handleInterBankTransfer}
          >
            {isInterBankLoading ? (
              <ActivityIndicator size="small" color={Colours.PRIMARY} />
            ) : (
              <Text
                style={{
                  color: isButtonClickedd ? "white" : Colours.DARKGRAY,
                  fontSize: dynamicFontSize(17),
                  fontFamily: "Sen-Bold",
                }}
              >
                Bank Transfer
              </Text>
            )}
          </TouchableOpacity>
           */}
        </View>

        <View style={styles.textboxAmountContainer5}>
          <View style={styles.textboxHeader}>
            <Text style={styles.meezaCreditBalanceTxt}>Cash Out Balance</Text>
          </View>

          <View style={styles.tableAmountContainer}>
            {/* <MoneyIcon color={Colours.PRIMARY_LIGHT} width={dynamicSize(30)} height={dynamicSize(30)} /> */}
            <Text style={styles.creditsTxt}>Cash Out:</Text>
            {isLoadings ? (
              <ActivityIndicator size="small" color={Colours.PRIMARY} />
            ) : (
              <>
                <Text style={styles.creditsValueTxt}>{isReverified ? cashOut : "**** "}</Text>
                {isReverified ? (
                  ""
                ) : (
                  <TouchableOpacity
                    onPress={() => {
                      setShowUsernamePasswordTransactCode(true);
                    }}
                  >
                    <ViewMoreIcon color={Colours.MIDGRAY} />
                  </TouchableOpacity>
                )}
              </>
            )}
          </View>
          <TouchableOpacity
            style={[
              styles.buttonGray,
              { backgroundColor: isButtonClickedd ? Colours.PRIMARY : Colours.LIGHTGRAY },
            ]}
            onPress={handleInterBankTransfer}
          >
            {isInterBankLoading ? (
              <ActivityIndicator size="small" color={Colours.PRIMARY} />
            ) : (
              <Text
                style={{
                  color: isButtonClickedd ? "white" : Colours.DARKGRAY,
                  fontSize: dynamicFontSize(17),
                  fontFamily: "Sen-Bold",
                }}
              >
                Bank Transfer
              </Text>
            )}
          </TouchableOpacity>
        </View>
        {/* 
        <View style={styles.textboxAmountContainer}>
          <Text style={styles.makeTransferTxt}>Make transfers to meeza users at no cost.</Text>

          <TouchableOpacity
            style={[
              styles.buttonGray,
              { backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
            ]}
            onPress={() => handleMeezaTransfer()}
          >
            {isMeezaLoading ? (
              <ActivityIndicator size="small" color={Colours.PRIMARY} />
            ) : (
              <Text
                style={{
                  color: isButtonClicked ? "white" : Colours.DARKGRAY,
                  fontSize: dynamicFontSize(17),
                  fontFamily: "Sen-Bold",
                }}
              >
                Meeza Transfer
              </Text>
            )}
          </TouchableOpacity>
        </View> */}

        <View style={styles.dataContainer} onPress={() => {}}>
          <View style={styles.dataSubContainer2}>
            <DoesIconn color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
            <View style={styles.captionAndDescribtion}>
              <View style={styles.flatArrowContainer}>
                <Text style={styles.joinDoingsTxt}>Join the Doings Trend</Text>
                {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
              </View>
              <Text style={styles.letPeopleSeeTxt}>Let People see your Doings</Text>
            </View>
          </View>

          <TouchableOpacity style={styles.dataContainer2} onPress={handleMeezaCredits}>
            <View style={styles.dataSubContainer}>
              <MoneyIcon color={Colours.PRIMARY} height={dynamicSize(25)} width={dynamicSize(25)} />
              <View style={styles.captionAndDescribtion}>
                <View style={styles.flatArrowContainer}>
                  <Text style={styles.buyMeezaTxt}>Buy Meeza Credits </Text>
                  {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
                </View>
                <Text style={styles.doingsDescribeTxt}>
                  You can only join the doings trend by purchasing meeza credits. Spend more meeza
                  credits and watch your profile or table move up the doings trend
                </Text>
              </View>
            </View>
          </TouchableOpacity>
        </View>

        <View style={styles.dataContainer3} onPress={() => {}}>
          <TouchableOpacity
            style={styles.dataContainer2}
            onPress={handleViewMeezaCreditTransactions}
          >
            <View style={styles.dataSubContainer}>
              <ClockIcon color={Colours.PRIMARY} width={dynamicSize(25)} height={dynamicSize(25)} />
              <View style={styles.captionAndDescribtion}>
                <View style={styles.flatArrowContainer}>
                  <Text style={styles.creditTransactHistoryTxt}>
                    Meeza Credit Transaction History{" "}
                  </Text>
                  {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
                </View>
                {/* <Text style={{ width: 250, color: Colours.DARKLIGHTGRAY, fontSize: 13, fontFamily: 'Sen-Regular' }}>You can only join the doingz trend by purchasing meeza credits. Spend more meeza credits and watch your profile or table move up the doingz trend</Text> */}
              </View>
            </View>
          </TouchableOpacity>
        </View>
      </ScrollView>

      <Modal
        animationType="slide"
        visible={showMeezaCreditTransactHistory}
        onRequestClose={() => setShowMeezaCreditTransactHistory(false)}
      >
        <TopHeaderComponent
          headerText={"Credit Transaction History"}
          hideScreen={() => setShowMeezaCreditTransactHistory(false)}
        />
        <ScrollView
          style={styles.componentStyle2}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <MeezaCreditTransactionHistory />
        </ScrollView>
      </Modal>

      <Modal
        animationType="slide"
        visible={showTransferTo}
        onRequestClose={() => setShowTransferTo(false)}
      >
        <TopHeaderComponent
          headerText={"Meeza Transfers"}
          hideScreen={() => setShowTransferTo(false)}
        />
        <ScrollView
          style={styles.componentStyle2}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <TransferTo />
        </ScrollView>
      </Modal>

      <Modal
        animationType="fade"
        visible={showTransferFromMeezaCredit}
        onRequestClose={() => setShowTransferFromMeezaCredit(false)}
      >
        <TopHeaderComponent
          headerText={"Transfer From Meeza Credit"}
          hideScreen={() => setShowTransferFromMeezaCredit(false)}
        />
        <ScrollView
          // ref={scrollViewRef}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            {/**Note: This component  is named wrongly since not just table that uses it but meezaCredits as well */}
            <TransferFromTable
              showConfirmTransfer={showConfirmTransfer}
              setShowConfirmTransfer={setShowConfirmTransfer}
              showPaymentReceipt={showPaymentReceipt}
              setShowPaymentReceipt={setShowPaymentReceipt}
              hideAllPayScreens={hideAllPayScreens}
            />
          </View>
        </ScrollView>
      </Modal>

      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>

      <Modal
        visible={showUsernamePasswordTransactCode}
        //  transparent={true}
        animationType="fade"
        onRequestClose={() => setShowUsernamePasswordTransactCode(false)}
      >
        <UsernamePasswordTransactCode
          hideModal={() => setShowUsernamePasswordTransactCode(false)}
          setPasswordIsCorrect={setPasswordIsCorrect}
        />
      </Modal>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
    paddingTop: dynamicSpacing(20),
  },
  meezaCreditBalanceTxt: {
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(15),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
  },
  creditsTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  creditsValueTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(20),
    fontFamily: "Sen-Bold",
  },
  makeTransferTxt: {
    marginTop: dynamicSpacing(10),
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  creditTransactHistoryTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  componentStyle2: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
    paddingTop: dynamicSpacing(10),
  },
  textboxAmountContainer: {
    margin: dynamicSpacing(15),
    marginTop: dynamicSpacing(15),
    marginBottom: dynamicSpacing(5),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxAmountContainer2: {
    margin: dynamicSpacing(15),
    marginTop: dynamicSpacing(0),
    marginBottom: dynamicSpacing(0),
    padding: dynamicSpacing(15),
    paddingTop: dynamicSpacing(0),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxAmountContainer5: {
    margin: dynamicSpacing(15),
    marginTop: dynamicSpacing(15),
    marginBottom: dynamicSpacing(0),
    padding: dynamicSpacing(15),
    paddingTop: dynamicSpacing(0),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxAmountContainer3: {
    margin: dynamicSpacing(15),
    marginTop: dynamicSpacing(0),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(1),
  },
  textBoxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(10),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
    borderWidth: dynamicSize(2),
  },
  inputTxt: {
    height: dynamicSize(40),
    width: dynamicSize(250),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSize(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
    marginBottom: dynamicSpacing(10),
    marginRight: dynamicSpacing(10),
  },
  tableAmountContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
    marginBottom: dynamicSpacing(10),
  },
  buttonGray: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(10),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
  dataContainer3: {
    display: "flex",
    backgroundColor: "white",
    margin: dynamicSpacing(10),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  dataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  dataContainer2: {
    display: "flex",
    borderWidth: dynamicSize(1),
    borderColor: Colours.PRIMARY_LIGHTER,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },

  dataContainer: {
    display: "flex",
    backgroundColor: "white",
    margin: dynamicSpacing(10),
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(5),
  },
  dataSubContainer2: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
    marginBottom: dynamicSpacing(10),
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(260),
    marginBottom: dynamicSpacing(5),
  },
  captionAndDescribtion: {
    display: "flex",
  },
  buyMeezaTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  doingsDescribeTxt: {
    width: dynamicSize(250),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  joinDoingsTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  letPeopleSeeTxt: {
    width: dynamicSize(260),
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
});

export default MeezaCreditScreen;
